import { videoAxiosInstance } from './axiosInstances.service';

export enum BANDWIDTH_CONNECTION {
  GOOD = 'good',
  SLOW = 'slow',
  VERY_SLOW = 'very_slow',
}

export const enum EVENT_TYPES {
  PAGE_OPEN = 'pageOpen',
  FORM_FILLED = 'formFilled',
  START_INTERVIEW = 'startInterview',
  DOCUMENT_UPLOADED = 'documentUploaded',
  TOP_TIPS_CLICKED = 'topTipsClicked',
  TOP_TIPS_LIKED = 'topTipsLiked',
  TOP_TIPS_DISLIKED = 'topTipsDisliked',
  INTRO_VIDEO_PLAYED = 'introVideoPlayed',
  OPEN_WIDGET = 'openWidget',
  WELCOME_STATE_START_BUTTON = 'welcomeStateStartButton',
  WELCOME_STATE_TOP_TIPS = 'welcomeStateTopTips',
  WELCOME_STATE_VIDEO_PLAY = 'welcomeStateVideoPlay',
  WELCOME_STATE_VIDEO_PAUSE = 'welcomeStateVideoPause',
  WELCOME_STATE_VIDEO_FULLY_WATCHED = 'welcomeStateVideoFullyWatched',
  PERMISSION_DENIED = 'permissionsDenied',
  PERMISSION_GRANTED = 'permissionsGranted',
  CAMRTA_INITIALIZED = 'cameraInitialized',
  MIC_INITIALIZED = 'micInitialized',
  BANDWIDTH_CHECK = 'bandwidthCheck',
  VIDEO_QUESTION_PLAY = 'videoQuestionPlay',
  VIDEO_QUESTION_PAUSE = 'videoQuestionPause',
  VIDEO_QUESTION_WATCHED = 'videoQuestionWatched',
  PRACTICE_CLICKED = 'practiceClicked',
  PRACTICE_PRESENTED = 'practicePresented',
  PRACTICE_STARTED = 'practiceStarted',
  PRACTICE_ENDED = 'practiceEnded',
  PRACTICE_FINISHED = 'practiceFinished',
  PRACTICE_SKIPPED = 'practiceSkipped',
  START_CLICKED = 'startClicked',
  QUESTION_PRESENTED = 'questionPresented',
  QUESTION_STARTED = 'questionStarted',
  QUESTION_ENDED = 'questionEnded',
  RETAKE_CLICKED = 'retakeClicked',
  WIDGET_MINIMIZED = 'widgetMinimized',
  NO_SOUND = 'noSound',
  CAMERA_CHANGED = 'cameraChanged',
  MICROPHONE_CHANGED = 'microphoneChanged',
  SOUND_RESTORED = 'soundRestored',
  TIMES_UP = 'timesUp',
  COMPLETED_INTERVIEW = 'completedInterview',
  RECONNECTED = 'reconnected',
  CONFIRM_UPLOADED_FAILED = 'confirmUploadedFailed',
  FINISHED = 'finished',
  ON_FINISH_SUCCEED = 'onFinishSucceed',
  ON_FINISH_FAILED = 'onFinishFailed',
}

export type IEventType = `${EVENT_TYPES}`;

export interface ITrackEvent {
  eventType: IEventType;
  extraData?: any;
}

let event_id: string | undefined;

export const updateEventId = (eventId: typeof event_id):void => { event_id = eventId; };

export const emitTrackEvent = (eventData: ITrackEvent):void => {
  event_id && videoAxiosInstance.post(`/event/${event_id}`, eventData);
};
